import i18n from '@/locale/i18n'

const Home = r => require.ensure([], () => r(require('../../page/newYear/apply/home')), 'home')
const signSelect = r => require.ensure([], () => r(require('../../page/newYear/apply/signSelect')), 'signSelect')
const applicationCode = r => require.ensure([], () => r(require('../../page/newYear/apply/applicationCode')), 'applicationCode')
const applicationForm = r => require.ensure([], () => r(require('../../page/newYear/apply/applicationForm')), 'applicationForm')
const result = r => require.ensure([], () => r(require('../../page/newYear/apply/result')), 'result')
const sign = r => require.ensure([], () => r(require('../../page/newYear/sign/index')), 'index')
const signStatus = r => require.ensure([], () => r(require('../../page/newYear/sign/status')), 'status')
const signError = r => require.ensure([], () => r(require('../../page/newYear/sign/error')), 'error')
const query = r => require.ensure([], () => r(require('../../page/newYear/query/home')), 'home')
const queryStatus = r => require.ensure([], () => r(require('../../page/newYear/query/status')), 'status')
export default [
  {
    path: '/activity/home',
    component: Home,
    meta: { title: i18n.t('activity.activity2') }
  },
  {
    path: '/activity/signUpEntry',
    component: signSelect,
    meta: { title: i18n.t('activity.activity28') }
  },
  {
    path: '/activity/applicationCode',
    component: applicationCode,
    meta: { title: i18n.t('activity.activity28') }
  },
  {
    path: '/activity/applicationForm',
    component: applicationForm,
    meta: { title: i18n.t('activity.activity28') }
  },
  {
    path: '/activity/result',
    component: result,
    meta: { title: i18n.t('activity.activity28') }
  },
  {
    path: '/activity/sign',
    component: sign,
    meta: { title: i18n.t('sign.sign2') }
  },
  {
    path: '/activity/signStatus',
    component: signStatus,
    meta: { title: i18n.t(`sign.sign12`) }
  },
  {
    path: '/activity/signError',
    component: signError,
    meta: { title: i18n.t(`sign.sign12`) }
  },
  {
    path: '/activity/query',
    component: query,
    meta: { title: i18n.t(`weWalk.weWalk1`) }
  },
  {
    path: '/activity/queryStatus',
    component: queryStatus,
    meta: { title: i18n.t(`weWalk.weWalk17`) }
  }
]



// WEBPACK FOOTER //
// ./src/router/newYear/index.js